import ProjectCreateUpdateView from './ProjectCreateUpdateView';
import './ProjectCreateUpdateView.scss';

export default ProjectCreateUpdateView;
